export const detectDeviceType = () => {
    const userAgent = navigator.userAgent.toLowerCase();

    // Check for mobile devices and tablets
    // NB. True Fit API only accepts 'mobile' or 'desktop'
    // So I'm including tablets as 'mobile'
    const mobileDevicesAndTablets =
        /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
            userAgent
        );
    if (mobileDevicesAndTablets) {
        return 'mobile';
    }

    // Check for desktop devices
    const desktopDevices = /win|mac|linux/i.test(userAgent);
    if (desktopDevices) {
        return 'desktop';
    }

    return 'unknown';
};
